<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>配货信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="content-caption dashed bg-white">
            <span>基本信息</span>
        </div>
        <div class="form-single">
            <div class="title required">标题</div>
            <div class="content">
                <el-input class="width-2x" v-model="title" @blur="titleBlur()"></el-input>
            </div>
        </div>
        <div class="form-single" style="overflow: visible;margin-bottom: 15px">
            <div class="title required">要求到货日期</div>
            <el-form :rules="validateRules" ref="arriveDate">
                <div class="content">
                    <el-form-item class="mr20" prop="desireArriveDate">
                        <el-date-picker v-model="desireArriveDate" :picker-options="pickerOptions0" type="date" placeholder="选择日期" @change="compareDate"></el-date-picker>
                    </el-form-item>
                </div>
            </el-form>
        </div>

        <div class="block-container">
            <div class="content-caption dashed bg-white">
                <span>零售商机构信息</span>
            </div>

            <table class="custom-tbl">
                <thead class="head">
                <tr class="row">
                    <th class="align-left">机构名称</th>
                    <th class="align-left">地址</th>
                    <th>邮箱</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr v-if="retailerCom != null" class="row">
                    <td class="align-left">{{retailerCom.name}}</td>
                    <td class="align-left">{{retailerCom.regionName + retailerCom.street}}</td>
                    <td>{{retailerCom.contactEmail}}</td>
                </tr>
                <tr class="row" v-else>
                    <td colspan="3">无配货机构信息</td>
                </tr>
                </tbody>
            </table>
            <div v-if="retailerCom != null && retailerCom.shopAddrRegionId != null">
                <!--增加收货地址-->
                <div class="content-caption dashed bg-white">
                    <span>收货地址</span>
                    <a class="swb-btn-link" @click="showShopAddrDlg()">选择</a>
                </div>
                <table class="custom-tbl">
                    <colgroup>
                        <col>
                        <col>
                        <col width="150px">
                        <col width="150px">
                        <!--<col width="150px">-->
                    </colgroup>
                    <thead class="head">
                    <tr class="row">
                        <th class="align-left">省市县</th>
                        <th class="align-left">详细地址</th>
                        <th class="align-left">联系人</th>
                        <th>电话</th>
                        <!--<th>操作</th>-->
                    </tr>
                    </thead>
                    <tbody class="body">
                    <tr v-if="retailerCom != null" class="row">
                        <td class="align-left">{{retailerCom.shopAddrRegionName || ''}}</td>
                        <td class="align-left">
                            <el-input class="inline-block" placeholder="详细地址" style="width: 500px" v-model="retailerCom.shopAddrStreet"></el-input>
                        </td>
                        <td class="align-left">
                            <el-input type="input" v-model="retailerCom.shopRecvContactName"></el-input>
                        </td>
                        <td>
                            <el-input type="input" v-model="retailerCom.shopRecvContactTel"></el-input>
                        </td>
                        <!--<td>-->
                        <!--<a class="font-blue" @click="showShopAddrDlg()">更换</a>-->
                        <!--</td>-->
                    </tr>
                    <tr class="row" v-else>
                        <td colspan="3"><a @click="showShopAddrDlg()" class="font-blue">选择地址</a></td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="content-caption dashed bg-white">
                <span>商品信息</span>
            </div>
            <div>
                <el-form :model="goodsOrderItem" ref="goodsOrderItem">
                    <el-table ref="multipleTable" :data="goodsOrderItemList" border tooltip-effect="dark" style="width: 100%">
                        <el-table-column align="left" prop="title" label="名称"></el-table-column>
                        <el-table-column align="left" width="120" prop="catName" label="分类名称"></el-table-column>
                        <el-table-column align="left" width="120" prop="brandName" label="品牌"></el-table-column>
                        <el-table-column align="right" prop="price" label="含税价(元)" width="80">
                            <template slot-scope="scope">
                                <span>{{scope.row.price || 0.00}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="taxRate" label="税率(%)" width="80">
                            <template slot-scope="scope">
                                <span>{{scope.row.taxRate || 0}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="ntxPrice" label="未税价(元)" width="80">
                            <template slot-scope="scope">
                                <span>{{scope.row.ntxPrice || 0.00}}</span>
                            </template>
                        </el-table-column>

                        <el-table-column align="right" width="100" prop="wrntPeriod" label="质保期（月）"></el-table-column>
                        <el-table-column align="right" width="80" prop="quantity" label="订单总数量"></el-table-column>
                        <el-table-column align="right" width="80" prop="allocSumQuantity" label="已配货数量"></el-table-column>
                        <el-table-column align="right" width="80" prop="allocSumQuantity" label="可配数量">
                            <template slot-scope="scope">
                                <span>{{scope.row.quantity - scope.row.allocSumQuantity}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="110" prop="allocQuantity" label="本次配货数量">
                            <template slot-scope="scope">
                                <el-form-item :prop="'goodsOrderItemList' + scope.$index + 'allocQuantity'" :rules="{validator: validateQuantity, trigger: 'blur'}">
                                    <el-input :disabled="(scope.row.quantity - scope.row.allocSumQuantity) <= 0" type="input" v-model="scope.row.allocQuantity"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" width="150" label="说明">
                            <template slot-scope="scope">
                                <el-input type="text" v-model="scope.row.desc"></el-input>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form>
            </div>
        </div>

        <div class="form-toolbar">
            <button class="swb-btn swb-btn-small swb-btn-primary" @click="prevContract()">返回</button>
            <button class="swb-btn swb-btn-small" @click="saveOrderGoodsAllocItem()">保存</button>
        </div>
    </div>

</template>


<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import goodsOrderApi from '../../api/goodsOrder'
    import retailerApi from '../../api/retailer'
    import { openRetailComTreeSelectDlg } from '../retailer/selectDlg';

    import SwbShopListForSelect from '../merchant/ShopListForSelect';
    Vue.regist(SwbShopListForSelect);

    import SwbShowGoodsOrder from './ShowGoodsOrder';
    Routes.add(SwbShowGoodsOrder);

    export default {
        name: 'swb-order-goods-alloc-item-save',
        path: '/order/goods/alloc/item/save',
        avlActions: '',
        avlScopes: 'servicer',
        notAsResc: true,
        authen: false,
        desc: '配货信息编辑',
        data: function () {
            let self = this;
            // 校验
            let validateDesireArriveDate = function (rule, value, callback) {
                let desireArriveDate = self.desireArriveDate;
                if(Utils.isNoB(desireArriveDate)) {
                    callback(new Error('请选择要求到货日期'));
                } else {
                    callback();
                }
            };
            return {
                merchantId: null,
                retailerCom: null,
                goodsOrderItem: {},
                goodsOrderItemList: [],
                desireArriveDate: null,
                title: null,
                orderId: null,
                goodsOrder: {},
                loading: false,
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                // 校验
                validateRules: {
                    desireArriveDate: [
                        {validator: validateDesireArriveDate, trigger: 'blur'}
                    ]
                }
            }
        },
        created: function () {
            //
            let orderId = this.$route.query.orderId || null;
            this.orderId = orderId;
            //
            this.getGoodsOrderById(orderId);
        },
        methods: {
            titleBlur: function () {
                if(Utils.isNoB(this.title)) {
                    MsgBox.warning("标题不能为空！");
                }
            },
            compareDate: function (value) {
                if(new Date(value).getTime() > new Date(this.goodsOrder.desireArriveDate).getTime()) {
                    Toast.show('选择的日期大于订单要求到货日期：【' + new Date(this.goodsOrder.desireArriveDate).format("yyyy-MM-dd") + "】", 3000, 'warning');
                }
            },
            validateQuantity: function (rules, value, callback) {
                if(!Utils.isNoB(value)) {
                    if(!Utils.isNumber(value)) {
                        callback(new Error('请输入正整数！'));
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            },
            // 选择门店
            showShopDlg: function () {
                let self = this;
                let dlgConfig = {};
                dlgConfig.isRadio = true;
                dlgConfig.isShowIcons = false;
                dlgConfig.comId = self.goodsOrder.buyerId;
                openRetailComTreeSelectDlg(dlgConfig, function (result) {
                    self.retailerCom = result;
                    self.getGoodsOrderRecv();
                });
            },
            // @date 2019-02-19 18:56 @author libin @desc 增加根据shopId和orderId查询对应的地址信息
            getGoodsOrderRecv: function () {
                let self = this;
                let retailerCom = self.retailerCom;
                let msgBoxDlg = MsgBox.loading();
                let postData = {};
                postData.orderId = self.orderId;
                postData.buyerShopId = retailerCom.id;
                goodsOrderApi.getOrderGoodsRecvAddrByShopIdAndOrderId(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == "info") {
                        let orderGoodsRecvAddr = result.data;
                        if(orderGoodsRecvAddr != null) {
                            retailerCom.shopAddrRegionId = orderGoodsRecvAddr.buyerRecvRegionId;
                            retailerCom.shopAddrRegionName = orderGoodsRecvAddr.buyerRecvRegionName;
                            retailerCom.shopAddrStreet = orderGoodsRecvAddr.buyerRecvStreet;
                            retailerCom.shopRecvContactTel = orderGoodsRecvAddr.buyerRecvContactTel;
                            retailerCom.shopRecvContactName = orderGoodsRecvAddr.buyerContactName;
                        } else {
                            self.getRetailerAddrListByComId(retailerCom.id);
                            retailerCom.shopRecvContactName = retailerCom.contactName;
                            retailerCom.shopRecvContactTel = retailerCom.contactTel;
                        }
                        self.retailerCom = Utils.merge({}, retailerCom);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            getRetailerAddrListByComId: function (shopId) {
                let self = this;

                let postData = {};
                postData.comId = shopId;
                postData.recvFlag = true;
                postData.defRevcFlag = true;
                //
                retailerApi.getRetailerAddrList(postData, function (result) {
                    if(result.type === "info") {
                        let addrList = result.data;
                        let retailerCom = self.retailerCom;
                        if(addrList != null && addrList.length > 0) {
                            let addr = addrList[0];
                            retailerCom.shopAddrAlias = addr.alias;
                            retailerCom.shopAddrRegionId = addr.regionId;
                            retailerCom.shopAddrRegionName = addr.regionName;
                            retailerCom.shopAddrStreet = addr.street;
                        } else {
                            retailerCom.shopAddrAlias = "机构地址";
                            retailerCom.shopAddrRegionId = retailerCom.regionId;
                            retailerCom.shopAddrRegionName = retailerCom.regionName;
                            retailerCom.shopAddrStreet = retailerCom.street;
                        }
                        self.retailerCom = Utils.merge({}, retailerCom);
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            // 选择地址
            showShopAddrDlg: function () {
                let self = this;
                let goodsOrder = self.goodsOrder;
                Vue.$showDialog({
                    title: '选择机构收货地址',
                    width: 800,
                    height: 500,
                    showCloseBtn: true,
                    template: '<div>' +
                    '<swb-retailer-addr-select :comId="shopId" :checkBox = "false"  ref="swb_retailer_addr_list_select"></swb-retailer-addr-select>' +
                    '</div>',
                    data: {
                        shopId: goodsOrder.buyerComId
                    },
                    methods: {},
                    okClicked: function () {
                        let result = this.$refs.swb_retailer_addr_list_select.getDlgResult() || {};
                        if(result.type == 'info') {
                            let retailerCom = self.retailerCom;
                            let shopAddr = result.data;
                            retailerCom.shopAddrAlias = shopAddr.alias;
                            retailerCom.shopAddrRegionId = shopAddr.regionId;
                            retailerCom.shopAddrRegionName = shopAddr.regionName;
                            retailerCom.shopAddrStreet = shopAddr.street;
                            self.retailerCom = Utils.merge({}, retailerCom);
                            return true;
                        } else {
                            MsgBox.warning(result.message);
                        }
                        return false;
                    },
                    lifecycle: {}
                })
            },
            // 商品订单项
            getGoodsOrderItemList: function () {
                let self = this;

                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                postData.orderId = self.orderId;

                goodsOrderApi.getGoodsOrderItemList(postData, function (result) {
                    if(result.type === "info") {
                        let goodsOrderItemList = result.data;
                        for(let i = 0; i < goodsOrderItemList.length; i++) {
                            let goodsOrderItem = goodsOrderItemList[i];
                            goodsOrderItem.desc = null;
                        }
                        self.goodsOrderItemList = goodsOrderItemList;
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            // 商品订单信息
            getGoodsOrderById: function (orderId) {
                let self = this;
                let postData = {};
                postData.id = orderId;
                goodsOrderApi.getGoodsOrderInfo(postData, function (result) {
                    if(result.type == "info") {
                        self.goodsOrder = result.data;
                        self.desireArriveDate = self.goodsOrder.desireArriveDate;
                        self.getRetailerComId();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getRetailerComId: function () {
                let self = this;
                let goodsOrder = self.goodsOrder;
                let postData = {
                    comId: goodsOrder.buyerComId
                };
                retailerApi.getRetailerCom(postData, function (result) {
                    if(result.type == "info") {
                        self.retailerCom = result.data;
                        self.getGoodsOrderRecv();
                        self.getGoodsOrderItemList();
                    }
                })
            },
            // 生成配货信息
            saveOrderGoodsAllocItem: function () {
                let self = this;
                if(Utils.isNoB(this.title)) {
                    MsgBox.warning("标题不能为空！");
                    return;
                }
                let buyerShop = self.retailerCom;
                if(buyerShop == null) {
                    MsgBox.warning("请选择零售商机构");
                    return;
                }
                let goodsOrderItemList = self.goodsOrderItemList;
                if(goodsOrderItemList != null && goodsOrderItemList.length > 0) {
                    let orderGoodsAllocDto = {};
                    orderGoodsAllocDto.orderId = self.orderId;
                    orderGoodsAllocDto.buyerShopId = buyerShop.id;
                    orderGoodsAllocDto.buyerRecvRegionId = buyerShop.shopAddrRegionId;
                    orderGoodsAllocDto.buyerRecvStreet = buyerShop.shopAddrStreet;
                    if(Utils.isNoB(buyerShop.shopRecvContactName)) {
                        MsgBox.warning("请输入收货联系人");
                        return;
                    }
                    if(Utils.isNoB(buyerShop.shopRecvContactTel)) {
                        MsgBox.warning("请输入收货联系电话");
                        return;
                    }
                    if(!Utils.isPhoneNo(buyerShop.shopRecvContactTel)) {
                        MsgBox.warning("请输入正确的电话号码");
                        return;
                    }
                    orderGoodsAllocDto.buyerRecvContactTel = buyerShop.shopRecvContactTel;
                    orderGoodsAllocDto.buyerRecvContactName = buyerShop.shopRecvContactName;
                    //
                    let orderGoodsAllocItemList = [];
                    for(let i = 0; i < goodsOrderItemList.length; i++) {
                        let goodsOrderItem = goodsOrderItemList[i];
                        let allocQuantity = goodsOrderItem.allocQuantity;
                        if(!Utils.isNoB(allocQuantity) && !Utils.isNaturalStr(allocQuantity, true)) {
                            MsgBox.warning(goodsOrderItem.title + "请输入大于0的整数！");
                            return;
                        }
                        if(!Utils.isNoB(allocQuantity) && allocQuantity > 0) {
                            let leftQuantity = goodsOrderItem.quantity - goodsOrderItem.allocSumQuantity
                            if(allocQuantity > leftQuantity) {
                                MsgBox.warning("商品【" + goodsOrderItem.title + "】：配货数量必须小于等于可配数量！");
                                return;
                            }
                            //
                            let orderGoodsAllocItem = {};

                            let desireArriveDate = self.desireArriveDate;
                            if(Utils.isNoB(desireArriveDate)) {
                                MsgBox.warning("请选择要求到货日期");
                                return false;
                            }
                            let desireArriveDateFormat = desireArriveDate.format("yyyy-MM-dd");
                            orderGoodsAllocItem.desireArriveDate = desireArriveDateFormat;

                            orderGoodsAllocItem.skuId = goodsOrderItem.skuId;
                            orderGoodsAllocItem.quantity = goodsOrderItem.allocQuantity;
                            orderGoodsAllocItem.unit = goodsOrderItem.unit;
                            orderGoodsAllocItem.asmblAccFlag = goodsOrderItem.asmblAccFlag;
                            orderGoodsAllocItemList.push(orderGoodsAllocItem);
                        }
                    }
                    if(orderGoodsAllocItemList.length <= 0) {
                        MsgBox.warning("此机构最少配货一件商品");
                        return false;
                    }
                    orderGoodsAllocDto.itemList = orderGoodsAllocItemList;
                    orderGoodsAllocDto.title = self.title;
                    //
                    let msgBoxDlg = MsgBox.loading();
                    goodsOrderApi.saveOrderGoodsAllocItems(orderGoodsAllocDto, function (result) {
                        msgBoxDlg.close();
                        if(result.type === "info") {
                            let data = result.data;
                            self.$message.success("配货成功");
                            let pushDate = {};
                            pushDate.path = SwbShowGoodsOrder.path;
                            if(self.orderId != null) {
                                pushDate.query = {goodsOrderId: self.orderId, activeName: 'second'};
                            }
                            self.$router.push(pushDate);
                        } else {
                            self.$message.error(result.message);
                        }
                    });
                }
            },
            prevContract: function () {
                let self = this;
                let pushDate = {};
                pushDate.path = SwbShowGoodsOrder.path;
                if(self.orderId != null) {
                    pushDate.query = {goodsOrderId: self.orderId, activeName: 'second'};
                }
                self.$router.push(pushDate);
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/order/OrderGoodsAllocItemSave.vue